<script setup lang="ts">
import { computed, ref } from "vue";

const props = defineProps<{
  title: string;
  modelValue: string;
  placeholder: string;
  validator?: (val: string) => boolean | string;
  disabled?: boolean
}>();

const container = ref<HTMLElement | null>(null);
const input = ref<HTMLElement | null>(null);
const errstate = ref(false);
const errmesage = ref("");

const emit = defineEmits<{
  (e: "update:modelValue", data: string): void;
}>();
const value = computed({
  get() {
    return props.modelValue;
  },
  set(val: string) {
    if (props.validator) {
      const valid = props.validator(val);
      if (valid === true) {
        container.value?.classList.remove("error");
        errstate.value = false;
        errmesage.value = "";
      } else {
        container.value?.classList.add("error");
        errstate.value = true;
        errmesage.value = valid as string;
      }
    } else {
      container.value?.classList.remove("error");
    }
    emit("update:modelValue", val);
  },
});

const shake = () => {
  if (props.validator) {
    const valid = props.validator(value.value);
    if (valid === true) {
      container.value?.classList.remove("error");
      errstate.value = false;
      errmesage.value = "";
    } else {
      container.value?.classList.add("error");
      errstate.value = true;
      errmesage.value = valid as string;
    }
  }
  input.value?.classList.add("error-shake");
  container.value?.classList.add("error");
  setTimeout(() => {
    input.value?.classList.remove("error-shake");
  }, 500);
};
defineExpose({
  shake,
});
</script>
<template>
  <div ref="container" class="input-box" :class="{disabled}">
    <div class="title">{{ title }}</div>
    <textarea :placeholder="placeholder" ref="input" v-model="value" :disabled="disabled" :class="{disabled}"/>
    <span class="error-message">{{ errmesage }}</span>
  </div>
</template>
<style scoped>
.input-box {
  display: flex;
  padding: 0 12px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
}

.error-message {
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  text-align: left;
  color: #d51f26;
  height: 16px;
}

.title {
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 600;
  line-height: 16.34px;
  text-align: left;
  height: 16px;
  margin-bottom: 8px;
  color: #747474;
}

.input-box.error textarea {
  border: 1.5px solid #f9a3a6 !important;
}

.input-box.error .title {
  color: #d51f26;
}

textarea {
  height: 96px;
  width: 100%;
  padding: 8px;
  line-height: 20px;
  border: 1.5px solid #d8d8d8;
  border-radius: 4px;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  resize: none;
}

textarea::-webkit-scrollbar {
  width: 12px;
}

textarea::-webkit-scrollbar-thumb {
  background: rgba(116, 116, 116, 0.85);
  border-radius: 8px;
  border: 3px solid white;
}

textarea::-webkit-scrollbar-track {
  background: transparent;
  /* border-radius: 4px; */
}

textarea:focus:not(.disabled),
textarea:hover:not(.disabled) {
  border: 1.5px solid #a4a4a4;
  outline: none;
}

textarea::placeholder {
  color: #a4a4a4;
}

textarea:disabled {
  color: #747474;
  background: #ffffff;
  border-color: #D8D8D8;
}
</style>
